module.exports = __webpack_public_path__ + "static/img/product04-1.10efde28.png";